import { useState } from "react";

type PronunciationGuidanceProps = {
  itemName: string;
  ipa?: string | null;
  phonics?: string | null;
};

function PronunciationGuidance({ itemName, ipa, phonics }: PronunciationGuidanceProps) {
  const [showGuidance, setShowGuidance] = useState(false);

  if (!ipa && !phonics) {
    return null;
  }

  const tooltipId = `pronunciation-guidance-${itemName.replace(/[^a-zA-Z0-9_-]/g, "-")}`;

  return (
    <span
      className="pronunciation-guidance"
      onMouseEnter={() => setShowGuidance(true)}
      onMouseLeave={() => setShowGuidance(false)}
    >
      <button
        type="button"
        className="pronunciation-guidance-trigger"
        aria-describedby={showGuidance ? tooltipId : undefined}
        onFocus={() => setShowGuidance(true)}
        onBlur={() => setShowGuidance(false)}
        onClick={() => setShowGuidance(true)}
        onKeyDown={(event) => {
          if (event.key === "Escape") {
            setShowGuidance(false);
          }
        }}
      >
        Additional pronunciation guidance
      </button>
      {showGuidance ?
      <span id={tooltipId} role="tooltip" className="pronunciation-guidance-tooltip">
        <strong className="pronunciation-guidance-heading">Additional pronunciation guidance</strong>
        {ipa ? <span><strong>IPA:</strong> {ipa}</span> : null}
        {phonics ? <span><strong>Phonics:</strong> {phonics}</span> : null}
      </span> : null}
    </span>
  );
}

export default PronunciationGuidance;
